import { useSelector } from 'react-redux';
import { selectCurrentOrder } from 'Redux/Order/slice';
import { ReactComponent as Group } from 'Assets/decor/group.svg';
import { ReactComponent as Map } from 'Assets/links/map.svg';
import { formatDate } from 'Shared/Utils';
import styles from './Locations.module.scss';

export const Locations: React.FC = () => {
  const currentOrder = useSelector(selectCurrentOrder);

  return (
    <div className={styles.locations}>
      <Group className={styles.locations__image} />
      <ul className={styles.locations__list}>
        <li className={styles.locations__title}>Pick-up</li>
        <div className={styles.locations__location}>
          <li className={styles.locations__location__content}>
            {currentOrder?.pick_up_at}
          </li>
          <a
            href={`http://www.google.com/maps/place/${currentOrder?.coordinate_from}`}
            target="_blank"
            rel="noreferrer"
          >
            <Map
              className={styles.locations__location__icon}
              title="Show pick-up location on map"
            />
          </a>
        </div>
        <li className={styles.locations__date}>
          {formatDate({ date: currentOrder?.pick_up_date })}
        </li>
        <li className={styles.locations__title}>Delivery</li>
        <div className={styles.locations__location}>
          <li className={styles.locations__location__content}>
            {currentOrder?.deliver_to}
          </li>
          <a
            href={`http://www.google.com/maps/place/${currentOrder?.coordinate_to}`}
            target="_blank"
            rel="noreferrer"
          >
            <Map
              className={styles.locations__location__icon}
              title="Show delivery location on map"
            />
          </a>
        </div>
        <li className={styles.locations__date}>
          {formatDate({ date: currentOrder?.deliver_date })}
        </li>
      </ul>
    </div>
  );
};
